// The game's name and its one line, in one place. index.html's <title> and the manifest are static
// files and keep the literal.
export const GAME_NAME = 'Inbound';
export const TAGLINE = 'They come down the road. Nothing gets to the Command Center.';
